/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductKitComponentsService = {
  /**
   * Get Screen data
   *
   * */
  async getProductByCode(code) {
    const requestScreenData = {
      url: "api/Product",
      top: "1",
      filter: `Code eq '${code}'`,
      select:
        "Code,Description1,Description2,Description3,IsKit ,DateChanged,CreatedBy,ChangedBy,DateCreated",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getProductKit(code) {
    const requestScreenData = {
      url: "api/ProductKit",
      top: "1",
      filter: `KitCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getProductKitDetails(code, kitVersion) {
    const requestScreenData = {
      url: "api/ProductKitDetail",
      filter: `KitCode eq '${code}' and Version eq ${kitVersion}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async saveProductKit(payload) {
    var url = "api/Save_ProductKit";

    return await ApiService.post(url, payload, "String");
  },
};

export { ProductKitComponentsService };
